import React from 'react';
import { Link } from 'react-router-dom'

export default function SymbolLink({ symbol, is_white }) {

    return (
        <Link to={"/symbol/" + symbol} class={is_white ? "has-text-white" : "has-text-black"} style={{ textDecoration: "underline" }}>
            {symbol}
        </Link>
    );
}


// WEBPACK FOOTER //
// ./src/components/symbol-link.js